module.exports = __webpack_public_path__ + "static/img/home-video.eb824326.png";